export default (list, entityId, contactId = null) =>
	list.map((entity) => {
		if (entity.entityId === entityId)
			return {
				...entity,
				contacts: contactId === null ? [] : entity.contacts.filter(({userId}) => userId !== contactId)
			};
		return {...entity};
	});
